import React from 'react'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import useAuthorization from '../generic/hooks/useAuthorization/useAuthorization'
import MachineDetailSection from './MachineDetailSection'

/**
 * Story 175, CU5 (S101/S103) -- the machine calendar block keeps only its action: opening the calendar
 * configuration of this machine in a new tab (DL-17), and only with a calendar and the CALENDARS
 * permission. The shift, day, hours and OEE loss rows were removed at the PO's request (2026-09-29);
 * without the button there is nothing left to show, so the block is not painted at all.
 */
const MachineCalendarBlock = ({ detail }) => {
  const { t_ } = useSmartTranslation()
  const isUserAuthorized = useAuthorization()
  const { device } = detail
  const hasCalendar = device.calendarId !== null && device.calendarId !== undefined

  if (!hasCalendar || !isUserAuthorized('CALENDARS')) {
    return null
  }

  return (
    <MachineDetailSection testId='machine-calendar-block' title={t_('Machine calendar')}>
      <div className='mdd__actions'>
        {/* Contract §5/DL-17 freezes rel="noopener" verbatim; noopener is what protects the opener. */}
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a className='mdd__link-button' href={'/configuration/calendarInstance/' + device.calendarId} target='_blank' rel='noopener'>
          {t_('See machine calendar')}
        </a>
      </div>
    </MachineDetailSection>
  )
}

export default MachineCalendarBlock
